export class Layout extends Object {
  constructor(layoutJSON = {}) {
    super();
    this.setDefaultLayout();

    if (layoutJSON instanceof Layout) {
      this.updateAttributes(layoutJSON.dagAttributes);
    } else {
      this.updateAttributes(layoutJSON);
    }
  }

  /**
   * Initialize default layout parameters
   */
  setDefaultLayout() {
    this.dagHeight = 450;
    this.dagWidth = 900;
  }


  /**
   * Update the layout with the provided parameters
   * 
   * @param {Object} layoutJSON Revised layout parameters
   */
  updateAttributes(layoutJSON) {
    for (let key in layoutJSON) {
      if (key in this) {
        this[key] = layoutJSON[key];
      }
    }
  }
}